import { render } from "./BrowsePetsPage.vue?vue&type=template&id=cb96fd92&scoped=true"
import script from "./BrowsePetsPage.vue?vue&type=script&lang=js"
export * from "./BrowsePetsPage.vue?vue&type=script&lang=js"

import "./BrowsePetsPage.vue?vue&type=style&index=0&id=cb96fd92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb96fd92"]])

export default __exports__